import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';

import { selectors as operationSelectors } from 'ducks/uiOperations';
import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as serviceItemTypeActions, selectors as serviceItemTypeSelectors } from 'ducks/serviceItemTypeMaintenance/serviceItemType';

import { buildSearchLookUpDrawer, ISearchLookUpDrawerProperties } from '../SearchLookUpDrawer';
import { IApplicationState } from 'ducks/reducers';
import { IServiceItemTypeFacade } from 'api/swaggerTypes';

const ActivitySearchLookUpDrawer = buildSearchLookUpDrawer<IServiceItemTypeFacade>();

// We are declaring the props so that we get type-safety in the maps below.
type StateProps = Pick<ISearchLookUpDrawerProperties<IServiceItemTypeFacade>,
    'searchPlaceholder' | 'operationMode' | 'sortingFilters' | 'records' | 'selectedRecord' | 'selectedSortFilter' | 'selectedSortDirection' |
    'open' | 'isLoading' | 'nextPage' | 'prevPage' | 'pageSize' | 'totalPages' | 'loadingPrevPage' | 'loadingNextPage' |
    'keyField' | 'fieldsToDisplay' | 'searchParams' | 'variant' | 'getSearchFromMatchParams' | 'changeSelectedRecordCallBack'>;

type DispatchProps = Pick<ISearchLookUpDrawerProperties<IServiceItemTypeFacade>,
    'search' | 'searchById' | 'changeSelectedRecord' | 'onToggle' | 'fetchNextPage' | 'fetchPrevPage'>;

const mapStateToProps = (state: IApplicationState): StateProps => (
    {
        variant: 'ServiceItemType',
        searchPlaceholder: 'Search for Service Item Types...',
        operationMode: operationSelectors.operationMode(state),
        sortingFilters: [
            {
                filter: 'ServiceItemTypeId',
                label: 'Service Item Type'
            },
            {
                filter: 'Description',
                label: 'Description'
            }
        ],
        records: serviceItemTypeSelectors.all(state) || [],
        selectedRecord: serviceItemTypeSelectors.selected(state),
        selectedSortFilter: 'ServiceItemTypeId',
        selectedSortDirection: 'Ascending',
        open: uiSelectors.isCustomerLookUpOpen(state),
        isLoading: serviceItemTypeSelectors.isLoading(state),
        nextPage: serviceItemTypeSelectors.nextPage(state),
        prevPage: serviceItemTypeSelectors.prevPage(state),
        pageSize: serviceItemTypeSelectors.pageSize(state),
        totalPages: serviceItemTypeSelectors.totalPages(state),
        loadingPrevPage: serviceItemTypeSelectors.loadingPrevPage(state),
        loadingNextPage: serviceItemTypeSelectors.loadingNextPage(state),
        searchParams: {},
        keyField: 'ServiceItemTypeId',
        fieldsToDisplay: ['ServiceItemTypeId', null, 'Description', null],
        changeSelectedRecordCallBack: (matchParams: URLSearchParams, selectedRecord: any) => {
            if (selectedRecord) {
                matchParams.set('ServiceItemTypeId', selectedRecord.ServiceItemTypeId);
            }

            return matchParams.toString();
        },
        getSearchFromMatchParams: (matchParams: URLSearchParams) => {
            const serviceItemTypeId = matchParams.get('ServiceItemTypeId');
            if (serviceItemTypeId) {
                return {
                    id: serviceItemTypeId,
                };
            }

            return null;
        },
    });

const actionCreators: DispatchProps = {
    search: serviceItemTypeActions.search,
    searchById: serviceItemTypeActions.searchById,
    changeSelectedRecord: serviceItemTypeActions.setSelected,
    onToggle: uiActions.toggleCustomerLookUp,
    fetchNextPage: serviceItemTypeActions.fetchNextPage,
    fetchPrevPage: serviceItemTypeActions.fetchPrevPage
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ActivitySearchLookUpDrawer);
